import React from 'react';
import './OwnerTab.css';

const OwnerTab = ({
  teamId,
  ownerUid,
  directoryStatus,
  joinRequests,
  joinRequestsLoading,
  joinRequestsError,
  updateJoinRequestStatus,
  updatingRequestId,
  teamMembers,
  teamMembersLoading,
  teamMembersError,
  removeMemberFromTeam,
  updateMemberRole,
}) => {
  const statusClass = (status) =>
    status === 'approved' ? 'approved' : status === 'rejected' ? 'rejected' : 'pending';

  const handleRoleChange = (member, newRole) => {
    const normalized = (newRole || '').toLowerCase();
    if (!normalized) return;

    updateMemberRole(member, normalized);
  };

  if (!teamId) return null;
  const ownerMember = teamMembers.find((m) => m.id === ownerUid);

  return (
    <div className="settings-card">
      <h2>Owner Tools</h2>
      <p className="settings-subtitle">
        You are the owner of this team. Manage join requests and directory visibility.
      </p>
      <p className="settings-subtitle">
        Subscription owner:{' '}
        <strong>{ownerMember?.ign || ownerMember?.email || ownerUid || 'Unknown'}</strong>
      </p>

      <div className="directory-status-row">
        <span className="settings-label">Directory</span>
        <span className="status-pill pending">
          {directoryStatus || 'Your team will be published automatically when needed.'}
        </span>
      </div>

      {teamId && (
        <div className="owner-section owner-section--members">
          <h3>Team Members</h3>
          <p className="settings-subtitle">
            Manage who has access to your team. Removing a member clears their team access.
          </p>
          {teamMembersLoading && <p className="settings-status">Loading members...</p>}
          {teamMembersError && <p className="settings-status">{teamMembersError}</p>}
          {!teamMembersLoading && teamMembers.length === 0 && (
            <p className="settings-status">No members found for this team.</p>
          )}
          {teamMembers.length > 0 && (
            <div className="owner-table-wrapper">
              <table className="owner-table owner-members-table">
                <thead>
                  <tr>
                    <th>IGN</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {teamMembers.map((m) => (
                    <tr key={m.id}>
                      <td>{m.ign || '?'}</td>
                      <td className="wrap-cell">{m.email || '?'}</td>
                      <td>
                        <select
                          className="owner-role-select"
                          value={['coach', 'analyst', 'assistant_coach', 'player'].includes((m.role || '').toLowerCase()) ? String(m.role).toLowerCase() : 'player'}
                          onChange={(e) => handleRoleChange(m, e.target.value)}
                          disabled={m.role && m.role.toLowerCase() === 'superadmin'}
                        >
                          <option value="coach">Coach</option>
                          <option value="player">Player</option>
                          <option value="assistant_coach">Assistant Coach</option>
                          <option value="analyst">Analyst</option>
                        </select>
                        {m.id === ownerUid && (
                          <div className="settings-hint">Subscription Owner</div>
                        )}
                      </td>
                      <td className="actions-cell">
                        {m.id === ownerUid ? (
                          <span className="settings-hint">Owner access is protected</span>
                        ) : (
                          <button
                            className="action reject owner-remove-btn"
                            type="button"
                            onClick={() => removeMemberFromTeam(m)}
                          >
                            Remove from team
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      <div className="owner-section">
        <h3>Incoming Join Requests</h3>
        <p className="settings-subtitle">
          Requests submitted via Join Team for <strong>{teamId}</strong>
        </p>
        {joinRequestsLoading && <p className="settings-status">Loading requests...</p>}
        {joinRequestsError && <p className="settings-status">{joinRequestsError}</p>}
        {!joinRequestsLoading && joinRequests.length === 0 && (
          <p className="settings-status">No pending requests.</p>
        )}
        {joinRequests.length > 0 && (
          <div className="owner-table-wrapper">
            <table className="owner-table owner-requests-table">
              <thead>
                <tr>
                  <th>Player</th>
                  <th>Email</th>
                  <th>Message</th>
                  <th>Status</th>
                  <th>Submitted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {joinRequests.map((req) => (
                  <tr key={req.id}>
                    <td>{req.ign || '?'}</td>
                    <td>{req.email || '?'}</td>
                    <td className="message-cell">{req.message || '?'}</td>
                    <td className="status-cell">
                      <span className={`status-pill ${statusClass(req.status || 'pending')}`}>
                        {req.status || 'pending'}
                      </span>
                    </td>
                    <td>
                      {req.createdAt?.seconds
                        ? new Date(req.createdAt.seconds * 1000).toLocaleString()
                        : '?'}
                    </td>
                    <td>
                      {req.status === 'pending' ? (
                        <div className="request-actions actions-cell">
                          <button
                            className="action approve"
                            onClick={() => updateJoinRequestStatus(req, 'approved')}
                            disabled={updatingRequestId === req.id}
                          >
                            Approve
                          </button>
                          <button
                            className="action reject"
                            onClick={() => updateJoinRequestStatus(req, 'rejected')}
                            disabled={updatingRequestId === req.id}
                          >
                            Reject
                          </button>
                        </div>
                      ) : (
                        <span className={`status-pill ${statusClass(req.status)}`}>
                          {req.status}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

    </div>
  );
};

export default OwnerTab;
